<script lang="ts">
  import { Cuentas, type Cuenta } from '../../../lib/api';

  let { limit = 6 }: { limit?: number } = $props();
  let cuentas = $state<Cuenta[]>([]);
  let error = $state<string | null>(null);

  async function cargar() {
    error = null;
    try {
      const all = await Cuentas.list();
      cuentas = all.filter(c => c.estado === 'ABIERTA' || !c.estado).slice(0, limit);
    } catch (e: any) {
      error = e?.message ?? String(e);
    }
  }

  $effect(() => { cargar(); const t = setInterval(cargar, 60000); return () => clearInterval(t); });
</script>

<div class="panel">
  <header><h3>Cuentas abiertas</h3><button type="button" onclick={cargar}>↻</button></header>
  {#if error}<p class="err">{error}</p>{/if}
  {#if cuentas.length === 0 && !error}<p class="empty">Sin cuentas abiertas.</p>{:else}
    <ul>
      {#each cuentas as c (c.id)}
        <li>
          <strong>Q {(c.total ?? 0).toLocaleString('es-GT', { minimumFractionDigits: 2 })}</strong>
          <span>Paciente {c.pacienteId.slice(0, 8)} · {c.estado ?? 'ABIERTA'}</span>
        </li>
      {/each}
    </ul>
  {/if}
</div>

<style>
  .panel { border: 1px solid var(--glass-border); border-radius: var(--radius-xl); background: var(--glass-bg-card); backdrop-filter: var(--glass-blur); -webkit-backdrop-filter: var(--glass-blur); box-shadow: var(--glass-shadow); overflow: hidden; }
  header { display: flex; justify-content: space-between; padding: 0.65rem 0.85rem; border-bottom: 1px solid var(--glass-border); background: rgba(255,255,255,0.35); backdrop-filter: blur(8px); -webkit-backdrop-filter: blur(8px); }
  h3 { margin: 0; font-size: 0.88rem; font-weight: 700; }
  header button { border: 1px solid var(--glass-border); background: var(--glass-bg-card); border-radius: 999px; cursor: pointer; padding: 0.2rem 0.55rem; font-weight: 600; transition: all 0.2s; }
  header button:hover { background: var(--brand-surface); border-color: var(--brand-strong); color: var(--brand-deep); }
  ul { list-style: none; margin: 0; padding: 0; max-height: 240px; overflow: auto; }
  li { padding: 0.6rem 0.85rem; border-bottom: 1px solid var(--glass-border); display: flex; flex-direction: column; gap: 0.1rem; transition: background 0.15s; }
  li:hover { background: rgba(255,255,255,0.35); }
  strong { font-size: 0.85rem; color: var(--brand-deep); }
  span { font-size: 0.78rem; color: var(--text-secondary); }
  .empty, .err { padding: 0.85rem; font-size: 0.85rem; margin: 0; }
  .err { color: var(--danger); }
</style>
